import axios from "axios";
import { queryParams } from "../../../../utils/queryParams";

const instance = axios.create({
  baseURL: queryParams.apiVersion + "admin/organization_roles"
});

export const api = {
  getRoles(params) {
    return instance.get("", params);
  },
  getPermissions(params) {
    return instance.get("/permissions_list", params);
  },
  addRole(params) {
    return instance.post("", params);
  },
  getRoleById(id, params) {
    return instance.get(`/${id}`, params);
  },
  updateRole(id, params) {
    return instance.put(`/${id}`, params);
  },
  removeRole(id) {
    return instance.delete(`/${id}`);
  },

  getUsersPerRole(id) {
    return instance.get(`/users_list?id=${id}`);
  },
  getUsersWhoCanAssignRole(id) {
    return instance.get(`/users_can_assign_role?id=${id}`);
  },
  updateUsers(params) {
    return instance.post("/update_users", params);
  },
  copyRole(params) {
    return instance.post("/copy_role", params);
  }
};
